import {
  Box,
  Grid,
  Card,
  Avatar,
  Container,
  Typography,
  CardContent,
} from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";

// Dados para os cards de features
const features = [
  {
    icon: <StarBorderIcon fontSize="medium" sx={{ color: "#0052CC" }} />,
    title: "Melhores operadoras",
    description: "Acesso às principais operadoras do mercado",
    bgColor: "#E0F2FE", // Azul claro
  },
  {
    icon: <PeopleOutlineIcon fontSize="medium" sx={{ color: "#0052CC" }} />,
    title: "Planos para todos",
    description: "Soluções para famílias, empresas e indivíduos",
    bgColor: "#E0F2FE", // Azul claro
  },
  {
    icon: <ChatBubbleOutlineIcon fontSize="medium" sx={{ color: "#0052CC" }} />,
    title: "Suporte exclusivo",
    description: "Atendimento personalizado via WhatsApp",
    bgColor: "#E0F2FE", // Azul claro
  },
  {
    icon: (
      <PhoneInTalkOutlinedIcon fontSize="medium" sx={{ color: "#0052CC" }} />
    ),
    title: "Negociação especial",
    description: "Condições e preços diferenciados",
    bgColor: "#E0F2FE", // Azul claro
  },
];

export const FeaturesSection = () => {
  return (
    <Box
      sx={{
        pb: { xs: 6, md: 10 },
        backgroundColor: "#F9FAFB" /* Fundo claro */,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                variant="outlined"
                sx={{
                  textAlign: "center",
                  p: 3,
                  height: "100%",
                  borderRadius: "12px",
                  borderColor: "#E5E7EB", // Borda cinza clara
                  backgroundColor: "white",
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: feature.bgColor,
                    width: 56,
                    height: 56,
                    margin: "0 auto 16px auto",
                  }}
                >
                  {feature.icon}
                </Avatar>
                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold", mb: 1, color: "text.primary" }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
